export const API_URL_USER= "https://income-expense-trackers.onrender.com/api/v1/users";
export const API_URL_ACC="https://income-expense-trackers.onrender.com/api/v1/accounts";
export const API_URL_TRANSACTION="https://income-expense-trackers.onrender.com/api/v1/transactions";
